import React from "react";
import { Icon } from "../icon/Icon";
import { dispatchTrackingEvent } from "~assets/global/tracking/tracking-event";
import { getId } from "~assets/frontend/_util/getId";
export const GenericTextLink = ({ label, className, href, target, children, childrenBefore, tracking }) => {
    const trackClick = () => {
        if (tracking) {
            dispatchTrackingEvent(tracking);
        }
    };
    return (React.createElement("a", { className: className, href: href, target: target, onClick: trackClick, rel: target === "_blank" ? "noopener noreferrer" : "" },
        childrenBefore,
        React.createElement("span", null, label),
        children));
};
export const TextLink = ({ label, className, href, target, icon }) => {
    if (href.startsWith("http")) {
        if (icon === undefined) {
            icon = {
                identifier: "icon-external-link",
                position: "end",
            };
        }
        if (target === undefined) {
            target = "_blank";
        }
    }
    let iconStart, iconEnd = undefined;
    if (icon !== undefined) {
        const iconClassName = "before:bg-black-100 group-hover/textlink:before:bg-red-100 group-focus/textlink:before:bg-red-100 group-disabled/textlink:bg-black-40 dark:before:bg-white dark:group-hover/textlink:before:bg-white dark:group-focus/textlink:before:bg-white before:transition-colors";
        if (icon.position == "start") {
            iconStart = React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "mr-6 " + iconClassName });
        }
        if (icon.position == "end") {
            iconEnd = React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "ml-6 " + iconClassName });
        }
    }
    return (React.createElement(GenericTextLink, { className: `group/textlink :disabled:text-black-30 group inline-flex items-center underline-offset-[4px] transition-colors active:underline hocus:text-red-100 dark:text-white dark:hocus:text-white dark:hocus:underline ${className ? className : ""}`, label: label, href: href, target: target, childrenBefore: iconStart, children: iconEnd }));
};
